import React__default from 'react';
import 'react/jsx-runtime';
import AlertTriangle from '../../../node_modules/@zooplus/icons/dist/es/components/AlertTriangle.js';
import CircleStrikethrough from '../../../node_modules/@zooplus/icons/dist/es/components/CircleStrikethrough.js';
import { P2, P1 } from '@zooplus/ui-components';
import { useTranslation } from '../../../hooks/use-translations.js';
import { formatMoney } from '../../../utils/utils.js';
import { ProgressBar } from '../progress-bar/ProgressBar.js';
import styles from './CartMovError.module.scss.js';
import purify from '../../../node_modules/dompurify/dist/purify.es.js';
import '../../../node_modules/@zooplus/commons-lang/dist/es/gen/lang.js';
import { useSiteContext } from '../../../node_modules/@zooplus/commons-lang/dist/es/components/SiteProvider.js';
import '../../../node_modules/@zooplus/commons-lang/dist/es/hooks/use-translation.js';

const CartMovError = (props) => {
    const { site, locale } = useSiteContext();
    const { t } = useTranslation(site.realm);
    const moneyLeftText = `${purify.sanitize(t('checkout.mov-error.money-left', {
        money: formatMoney(props.moneyLeft, props.currency, locale),
    }))}`;
    return (React__default.createElement("div", { className: styles.movError },
        React__default.createElement("div", { className: styles.inlineText },
            React__default.createElement(CircleStrikethrough, null),
            props.size === 'small' ? (React__default.createElement(P2, { dangerouslySetInnerHTML: { __html: moneyLeftText } })) : (React__default.createElement(P1, { dangerouslySetInnerHTML: { __html: moneyLeftText } }))),
        React__default.createElement("div", { className: styles.progressBarLine },
            React__default.createElement(ProgressBar, { max: props.mov, value: props.mov - props.moneyLeft }),
            React__default.createElement("div", null,
                React__default.createElement("b", null,
                    " ",
                    formatMoney(props.mov, props.currency, locale),
                    " "))),
        props.showAlert && (React__default.createElement("div", { className: `${styles.inlineText} ${styles.alertText}` },
            React__default.createElement(AlertTriangle, null),
            React__default.createElement(P1, null,
                " ",
                t('checkout.preview.extra-mov-error-info'),
                " ")))));
};

export { CartMovError };
//# sourceMappingURL=CartMovError.js.map
